import { type IDataObject } from '@inpart-io/devtools-iap';
import { type UploadManager } from '@inpart-io/padme-iap';
import { type Module } from 'vuex';

import { getActions } from './actions';
import { getGetters } from './getters';
import { getMutations } from './mutations';
import { type ICheckStatusState } from './types';

export function getBinaryUploadModule<T extends IDataObject>(manager: UploadManager<T>): Module<ICheckStatusState<T>, unknown> {
    return {
        namespaced: true,
        state: {
            statusList: new Map()
        },
        getters: getGetters<T>(),
        actions: getActions<T>(manager),
        mutations: getMutations<T>()
    };
}
